const configSky = {
    REACT_APP_DEFAULT_LOAN_OFFICER_USERNAME: "officer",
    REACT_APP_ENABLE_PRICING_BETA_MENU: false,
    REACT_APP_PRICING_BETA_EXTERNAL_PAGEID: "c9576149-9560-4349-b5a9-c656db0f7946",
    REACT_APP_CONDITION_WS_EXTERNALID: "a35a61bb-5b4b-45c5-aa7c-0fcdb1062857",
    REACT_APP_CONDITION_CORDEL_EXTERNALID: "28c7fba0-4725-49e5-a0c0-3724d66909b6",
    REACT_APP_CONDITION_CORNONDEL_EXTERNALID: "35360682-4850-439b-9fdd-a901e36d011d",
    REACT_APP_DOCUMENTS_WS_EXTERNALID: "bdfc5502-6fa8-4796-aeb1-9f519ae6d5b9",
    REACT_APP_DOCUMENTS_CORDEL_EXTERNALID: "7e02d788-475d-4d4b-9359-602c09a95c43",
    REACT_APP_DOCUMENTS_CORNONDEL_EXTERNALID: "257cdb27-c53e-4a6a-95f3-a351bf2563b2",
    REACT_APP_AIDOCUMENT_REVIEW: "bc86fbac-7586-41e8-ab5a-22059d5beeab",
    REACT_APP_VALIDATION_CREDIT_EXTERNAL: "78e39ca7-020a-4b52-9a73-bdf7dd3dfe7b"
};

export default configSky;
